import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import logo from './../assets/logofinal.svg';
import LoginBG from './../assets/hintergrund.jpg';

import AuthService from "../services/auth.service";

const ForgotPassword = () => {
  const [username, setUsername] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    let result = await AuthService.forgotPassword(username);
    setMessage(result.data.message);
  };

  function Copyright(props) {
    return (
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href="https://www.der-finanzierer.com/">
          Oliver Scholl - Der FINanzierer.com
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }

  return(
    <Grid container component="main" sx={{ height: '100vh' }}>
      <Grid item xs={12} sm={12} md={7} sx={{
          backgroundImage: `url(${LoginBG})`,
          backgroundRepeat: 'no-repeat',
          backgroundColor: (t) =>
            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
          backgroundSize: 'cover',
          backgroundPosition: 'left',
        }}
      />
      <Grid item xs={12} sm={12} md={5} component={Paper} elevation={6} px={6}>
        <Box sx={{ mt: -9, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <Box sx={{ textAlign: 'center'}}>
            <img style={{marginBottom: '20px'}} src={logo} alt="Logo" />
            <h2>Kundenportal</h2>
          </Box>
          <Form onSubmit={handleForgotPassword}>
            <Grid container spacing={2} my={4}>
              <Grid item xs={12} sx={{ textAlign: 'center' }}>
                <FormControl required sx={{ width: '100%' }}>
                  <TextField 
                    type="text" 
                    name="username" 
                    label="Ihre E-Mail Adresse" 
                    onChange={onChangeUsername} 
                    variant="outlined"
                    fullWidth
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center' }}>
                  {message && (
                    <div className="form-group">
                      <div className="alert alert-info" role="alert">
                        {message}
                      </div>
                    </div>
                  )}
                  <Button type="submit" variant="contained">
                    Passwort zurücksetzen
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Form>
          <Copyright />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
